import { useMutation } from '@tanstack/react-query'
import { PulseFilters } from 'api/pulse'
import { getRatingsByLocationCsv } from 'api/pulse/ratingsByLocation'
import fileDownload from 'js-file-download'
import { track } from 'lib/amplitude'

export function useRatingsByLocationDownloadCsv(query: PulseFilters) {
  return useMutation({
    mutationFn: async () => {
      track('button_click, pulse_download_csv_ratings_by_location', {
        filters: query,
      })
      const data = await getRatingsByLocationCsv(query)
      fileDownload(data, 'ratings_by_location.csv')
    },
  })
}
